export default __webpack_public_path__ + "static/media/a10.9fb0f0e0.png";